// Value formatting shared by the four Project Registers tabs (ProjectRegisters.js) and their
// customer-portal twins. Formatting only -- no components, no data access. It lives here rather than
// in one of the tabs because all four render money or dates and a second copy of "how we print a
// dollar figure" is a copy that drifts.

/** Date input wants `yyyy-mm-dd`; the API returns an ISO timestamp. */
export function toDateInput(value) {
  return value ? String(value).slice(0, 10) : '';
}

export function displayDate(value) {
  return value ? new Date(value).toLocaleDateString() : '—';
}

// Today, as the browser's local calendar date -- not `new Date().toISOString().slice(0, 10)`, which
// is UTC and reads back as tomorrow for anyone west of Greenwich in the evening (the same class of
// bug ADR 0009 names as "fixed twice" here, via new Date(string) rather than parseDateOnly -- this
// is the mirror-image mistake, going local-date-to-string instead of string-to-date).
export function todayDateInput() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

const MONEY = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 2,
});

/**
 * `null` renders as an em dash, not $0.00 -- on a register a customer reads, "no cost impact agreed
 * yet" and "costs nothing" are different statements, and the schema keeps them apart (nullable
 * amounts) specifically so the UI can too.
 *
 * A credit shows as -$115,000.00 rather than accounting parentheses: the registers these replace use
 * the minus sign, and parentheses read as a footnote on screen.
 */
export function money(value) {
  return value == null ? '—' : MONEY.format(value);
}

const MONEY_WHOLE = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
});

/**
 * For the summary cards only. Cents are noise on a $232,000 drawdown budget, and at 24px Georgia
 * (`.stat-value`) "$232,000.00" is wide enough to overflow a card at the narrow end of `.stat-row`'s
 * auto-fit grid. The grids and the balance table keep `money()` -- that's where the exact figure
 * belongs.
 */
export function moneyWhole(value) {
  return value == null ? '—' : MONEY_WHOLE.format(value);
}

const HOURS = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 });

export function hours(value) {
  return value == null ? '—' : HOURS.format(value);
}
